import { RequestResult } from '@ngneat/elf-requests';
import { filter, map, OperatorFunction, pipe } from 'rxjs';

/**
 * Helper operator to filter out requests that are still fetching and map the request result to a boolean indicating if the request succeeded
 * @returns Maps the request result to a boolean indicating if the request is completed and succeeded
 */
export const requestCompletedAndSucceeded = <TData>(): OperatorFunction<
  RequestResult & { data: TData },
  boolean
> => {
  return pipe(
    filter(({ status }) => status !== 'idle' && status !== 'loading'),
    map(({ isSuccess }) => isSuccess)
  );
};
